import { ReactNode } from 'react';

import classNames from 'classnames';

interface Props {
  className?: string;
  designVariant?: number;
  children: ReactNode;
}

export const Layout = ({ className, designVariant = 1, children }: Props) => {
  return <div className={classNames('layout', `design-v${designVariant}`, className)}>{children}</div>;
};

export const LayoutContainer = ({ children }: Props) => {
  return <div className="layout-main-container">{children}</div>;
};

export const LayoutContent = ({ children }: Props) => {
  return <div className="layout-main-container-children">{children}</div>;
};
